import {adbApi} from "./adbService";

export const languagesApi = adbApi.injectEndpoints({
    endpoints: (builder) => ({
        // Language page
        getLanguages: builder.query({
            query: () => ({
                url: "languages",
                method: "GET",
            }),
            providesTags: ["Languages"],
        }),
        createLanguage: builder.mutation({
            query: (body) => ({
                url: "languages",
                method: "POST",
                body
            }),
            headers: {
                "Content-Type": "multipart/form-data",
            },
            invalidatesTags: ["Languages"],
        }),
        updateLanguage: builder.mutation({
            query: ({id, body}) => ({
                url: `languages/${id}`,
                method: "POST",
                body
            }),
            invalidatesTags: ["Languages"],
        }),
        deleteLanguage: builder.mutation({
            query:  (id) => ({
                url: `languages/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["Languages"],
        }),
        getChangeLocal: builder.query({
            query: (locale) => ({
                url: `languages/change-language/${locale}`,
                method: "GET",
            }),
            providesTags: ["Languages"],
        }),
    }),
    overrideExisting: false,
});

export const {
    useLazyGetLanguagesQuery,
    useCreateLanguageMutation,
    useUpdateLanguageMutation,
    useDeleteLanguageMutation,
    useLazyGetChangeLocalQuery,
} = languagesApi;
